import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function PainPoints() {
  const painPoints: React.ReactNode[] = [<>
      Estás cansada de sentir que{' '}
      <span className="text-[#800020] font-bold" data-id="element-168">el dinero no alcanza</span> y
      que todo sube menos tus ingresos.
    </>, <>
      Quieres ayudar en casa con un extra, pero no puedes pasar{' '}
      <span className="text-[#800020] font-bold" data-id="element-169">horas cocinando</span>, ni
      gastar gas con el horno encendido.
    </>, <>
      Ya probaste vender postres "clásicos" (tortas, galletas, budines)… y
      terminaste con{' '}
      <span className="text-[#800020] font-bold" data-id="element-170">mucho trabajo</span>, poco
      margen y mucho desgaste.
    </>, <>
      <span className="text-[#800020] font-bold" data-id="element-171">Te frustra</span> que las
      recetas gratis de internet no te salgan igual: se cortan, se rajan, no
      cuajan, quedan con burbujas… y se pierde comida.
    </>, <>
      Te da miedo comprar algo digital y pensar: "¿y si pago y no me llega?" o
      "¿y si no era lo que esperaba?"
    </>];
  return <section className="py-16 px-4 bg-cream-dark border-y border-caramel/20" data-id="element-172">
      <div className="max-w-3xl mx-auto" data-id="element-173">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-brown-dark mb-10" data-id="element-174">
          Este recurso es para ti si…
        </h2>

        <div className="space-y-6 bg-white p-6 md:p-10 rounded-2xl shadow-sm border border-gray-100" data-id="element-175">
          {painPoints.map((point, index) => <div key={index} className="flex items-start group" data-id="element-176">
              <XCircleIcon className="w-6 h-6 text-urgency-red mt-1 mr-4 flex-shrink-0 group-hover:scale-110 transition-transform" data-id="element-177" />
              <p className="text-lg text-gray-700 font-medium leading-relaxed" data-id="element-178">
                {point}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}